// extracted by mini-css-extract-plugin
module.exports = {"SkipToMain":"SkipToMain__2S5BO"};